import LocationApi from 'api/LocationApi';

export const handleCitySearch = (text: string) =>
  LocationApi.searchCity(text).then(data =>
    data.map(city => ({
      value: city.id,
      title: city.displayName,
    }))
  );
